module.exports = __webpack_public_path__ + "img/triduum-logo-g-w.5ee0894c.svg";